import { useState } from 'react';
import { DateRangePicker } from './DateRangePicker';

// "Thu" + "7 Aug" faces for the date card (local-day safe).
function dvParts(iso: string): { dow: string; dm: string } {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(y ?? 0, (m ?? 1) - 1, d ?? 1);
  return {
    dow: dt.toLocaleDateString('en-GB', { weekday: 'short' }),
    dm: dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }),
  };
}

export interface DateFieldProps {
  value: string; // ISO, '' when unset
  today: string; // ISO
  label?: string; // the cell's eyebrow — "Day" by default
  onChange: (iso: string) => void;
}

// ONE DAY, the way the booking form picks two: the same .datecard cell, the same
// .calmodal, the same calendar — with a single cell and a single pick (Sir,
// 2026-09-02). A viewing's day used to be a bare <input type="date">, the one
// date in the app picked through the browser's own control.
export function DateField({ value, today, label = 'Day', onChange }: DateFieldProps) {
  const [calOpen, setCalOpen] = useState(false);
  const face = value
    ? (() => { const p = dvParts(value); return <><span className="dow">{p.dow}</span> {p.dm}</>; })()
    : <span className="dph">Select…</span>;
  return (
    <>
      <div className="datecard single">
        <button type="button" className={'dcell' + (calOpen ? ' active' : '')} onClick={() => setCalOpen((o) => !o)} aria-haspopup="dialog" aria-expanded={calOpen}>
          <div className="dk">{label}</div><div className="dv">{face}</div>
        </button>
      </div>
      {calOpen && (
        <div className="calmodal" onMouseDown={() => setCalOpen(false)}>
          <div className="calcard" onMouseDown={(e) => e.stopPropagation()}>
            <DateRangePicker single checkIn={value || null} checkOut={null} today={today}
              onChange={(r) => { if (r.checkIn) onChange(r.checkIn); }} onDone={() => setCalOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
}
